import PropTypes from 'prop-types';

export const groupsCustom = PropTypes.shape({
  all: PropTypes.objectOf(PropTypes.any),
  filtered: PropTypes.objectOf(PropTypes.any),
});

export const viewedProductGroupCustom = PropTypes.oneOfType([
  PropTypes.string,
  PropTypes.objectOf(PropTypes.any),
]);

export const inputDataCustom = PropTypes.shape({
  panelIRI: PropTypes.string,
  postIRI: PropTypes.string,
  cornerPostIRI: PropTypes.string,
  corners: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  openings: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  distance: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  color: PropTypes.string,
  height: PropTypes.string,
  type: PropTypes.string,
  accessories: PropTypes.arrayOf(PropTypes.object),
  accessoriesFlat: PropTypes.arrayOf(PropTypes.object),
  postGroupNumber: PropTypes.string,
  panelGroupNumber: PropTypes.string,
  panelDescription: PropTypes.string,
});

export const treeStructureSettingsCustom = PropTypes.shape({
  level: PropTypes.number,
  parentId: PropTypes.objectOf(PropTypes.string),
});
